import { atomWithStorage } from 'jotai/utils';

export const pageTypeAtom = atomWithStorage<string>('pageType', '');
